import { useEffect } from 'react';
import { Select, MenuItem, SelectChangeEvent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Chevron } from 'src/assets/svg/language-chevron.svg';
import { LanguagesCode } from 'src/i18n/constants';
import { getStorage, setLanguageStorage } from 'src/utils/local-storage-versioning';

import { styles } from './styles';
import { flagOptions } from './constants';

export const LanguageSelect = () => {
    const storage = getStorage();
    const {
        i18n: { changeLanguage, language },
    } = useTranslation();

    useEffect(() => {
        if (storage.language && storage.language !== language) {
            changeLanguage(storage.language);
        }
    }, []);

    const handleChange = (event: SelectChangeEvent<string>) => {
        const newLanguage = event.target.value as LanguagesCode;
        changeLanguage(newLanguage);
        setLanguageStorage(newLanguage);
    };

    const chevron = () => (
        <Chevron className="MuiSelect-custom-arrow-component" css={styles.chevron} />
    );

    return (
        <Select
            value={language}
            onChange={handleChange}
            variant="standard"
            disableUnderline
            IconComponent={chevron}
            MenuProps={{
                sx: styles.menuList,
            }}
            css={styles.container}
        >
            {flagOptions.map(({ code, label, iconSrc }) => (
                <MenuItem key={code} value={code} css={styles.menuItem}>
                    <img src={iconSrc} alt="flag-icon" css={styles.icon} />
                    <Typography variant="subtitle2" className="language-select__country-name">
                        {label}
                    </Typography>
                </MenuItem>
            ))}
        </Select>
    );
};
